import React from 'react'
import cn from 'classnames'
import Creatable from 'react-select/creatable'
import Select, { Props } from 'react-select'
import styles from './CustomSelectInput.module.scss'

export default function CustomSelect({className, ...customSelectProps}:Props) {
    const props: Props = { ...customSelectProps, className: cn(styles.select, className) }
    return props.creatable ? <Creatable {...props} /> : <Select {...props} />
}
